<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--引导块-->
			<div
				v-if="infoData"
				class="tips_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tips_main">
					<span>Home&nbsp;&nbsp;>&nbsp;&nbsp;Products&nbsp;&nbsp;>&nbsp;&nbsp;{{ infoData.parent_name }}&nbsp;&nbsp;>&nbsp;&nbsp;</span>{{ infoData.title }}
				</div>
			</div>
			<!--引导块-->
			<!--banner-->
			<div v-if="infoData" class="banner_box">
				<div class="banner_main">
					<div class="right"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<van-image width="100%" height="auto" :src="infoData.url" />
					</div>
					<div class="left">
						<div class="title1"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<span class="col_b">CorDx</span>&ensp;<span class="col_o">Tyfast</span>
						</div>
						<div class="title2"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="200"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/drug-rapid-test-cup/title.png" />
						</div>
						<div class="text"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
						>
							CorDx Tyfast Multi-Drug Rapid Test Cup is competitive binding, lateral flow immunochromatographic assay for qualitative and simultaneous detection of drug in human urine.
						</div>
						<div class="txt_box">
							<div class="txt_el"
								data-aos="fade-right"
								data-aos-duration="400"
								data-aos-delay="300"
								data-aos-offset="0"
								data-aos-once="true"
							><img src="../../assets/drug-rapid-test-cup/icon_1.png" />&ensp;FDA (510k) & CLIA-Waived</div>
							<div class="txt_el"
								data-aos="fade-right"
								data-aos-duration="400"
								data-aos-delay="600"
								data-aos-offset="0"
								data-aos-once="true"
							><img src="../../assets/drug-rapid-test-cup/icon_2.png" />&ensp;Can Screen Up to 15 Drugs of Abuse</div>
							<div class="txt_el"
								data-aos="fade-right"
								data-aos-duration="400"
								data-aos-delay="900"
								data-aos-offset="0"
								data-aos-once="true"
							><img src="../../assets/drug-rapid-test-cup/icon_3.png" />&ensp;Results in 5 Minutes</div>
							<div class="txt_el"
								data-aos="fade-right"
								data-aos-duration="400"
								data-aos-delay="1200"
								data-aos-offset="0"
								data-aos-once="true"
							><img src="../../assets/drug-rapid-test-cup/icon_4.png" />&ensp;Up to 99% Accurate</div>
							<div class="txt_el"
								data-aos="fade-right"
								data-aos-duration="400"
								data-aos-delay="1500"
								data-aos-offset="0"
								data-aos-once="true"
							><img src="../../assets/drug-rapid-test-cup/icon_5.png" />&ensp;Customizable Configurations</div>
							<div class="txt_el"
								data-aos="fade-right"
								data-aos-duration="400"
								data-aos-delay="1800"
								data-aos-offset="0"
								data-aos-once="true"
							><img src="../../assets/drug-rapid-test-cup/icon_6.png" />&ensp;Shelf Life: 24 Months</div>
						</div>
						<div v-if="false" class="btn_box"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="2500"
							data-aos-offset="0"
							data-aos-once="true"
						@click="goForm">Get a Quote</div>
					</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>Detect 15 Commonly Abused Drug Metabolites</div>
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Configuration of the CorDx Tyfast Multi-Drug Rapid Test Cup can consist of any combination of the below listed drug analytes.
					</div>
					<div class="table_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="500"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Performance Specifications: </div>
						<div class="table_el">
							<img src="../../assets/drug-rapid-test-cup/table.jpg" @click="showBig(require('@/assets/drug-rapid-test-cup/table.jpg'))" />
						</div>
						<div class="tips">*Based on the multi-site clinical study conducted in the US. </div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>WHAT IS INSIDE THE PACKAGE?</div>
					<div class="txt_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="txt_el">•&ensp;User Instructions</div>
						<div class="txt_el">•&ensp;Test Cup (inside foil pouch)</div>
						<div class="txt_el">•&ensp;Plastic Specimen Bag</div>
						<div class="txt_el">•&ensp;Identification Label (with confirmation ID)</div>
						<div class="txt_el">•&ensp;Pre-addressed mailing box for shipping samples for confirmation testing</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>TEST PROCEDURE</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/drug-rapid-test-cup/cup/cup.png" />
						<div class="txt_box">
							<div class="txt_el">
								<span class="left">
									1.
								</span>
								<span class="right">
									Remove the test cup from the sealed pouch and use it within one hour.
								</span>
							</div>
							<div class="txt_el">
								<span class="left">
									2.
								</span>
								<span class="right">
									Open the lid and collect the sample as indicated above, ensuring that the sample is above the minimum fill line.
								</span>
							</div>
							<div class="txt_el">
								<span class="left">
									3.
								</span>
								<span class="right">
									After urine specimen has been collected, close the lid securely and place the urine test cup on a flat surface.
								</span>
							</div>
							<div class="txt_el">
								<span class="left">
									4.
								</span>
								<span class="right">
									Remove the test window cover along and perforated line.
								</span>
							</div>
							<div class="txt_el">
								<span class="left">
									5.
								</span>
								<span class="right">
									Read the results at 5 minutes. Do not interpret the results after 5 minutes.
								</span>
							</div>
						</div>
					</div>
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>HOW DO I INTERPRET TEST RESULTS?</div>
					<div class="info_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="img_box">
							<img src="../../assets/drug-rapid-test-cup/results/negative result.png" />
						</div>
						<div class="title_box">
							<div class="tit">Negative:</div>
							<div class="txt">
								If a line shows in both the C - Control and the T - Test area, it means a negative result for the test drug, regardless of how dark or light the line may appear.
							</div>
						</div>
					</div>
					<div class="info_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="img_box">
							<img src="../../assets/drug-rapid-test-cup/results/positive result.png" />
						</div>
						<div class="title_box">
							<div class="tit">Positive:</div>
							<div class="txt">
								If a line appears in the C - Control area, but no line shows in the T - Test area, it means a Preliminary Positive result for the test drug.
							</div>
						</div>
					</div>
					<div class="info_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="img_box">
							<img src="../../assets/drug-rapid-test-cup/results/invalid result.png" />
						</div>
						<div class="title_box">
							<div class="tit">Invalid:</div>
							<div class="txt">
								NO line shows in the C - Control area, then the result is invalid. In such case, retest with a new device.
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="title"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>CorDx is Committed to <span>Trust and Quality</span></div>
				<div class="text"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				>
					CorDx is committed to providing diagnostic products of the highest
					caliber of quality for caregivers, for families, and for you. With world-
					renowned quality management systems across our global network,
					CorDx delivers reliable, precise diagnostic products.
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<template v-if="infoData">
				<div v-if="infoData.tags.length > 0" class="block_5"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">Downloadable Resources</div>
					<div class="list_box">
						<div v-for="(value, index) in infoData.tags" :key="index"
							class="list_el"
							:class="nowList == value.id ? 'actived' : ''"
							@click="listClick(value)"
						>{{ value.catname }}</div>
					</div>
					<div class="content" v-html="nowContent"></div>
				</div>
			</template>
			<!--块5-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import contact from '@/component/contact2.vue'  //联系我们
import { productInfo, productCount  } from '@/api/public_h5';
import md5 from 'js-md5';
import { ImagePreview } from 'vant';  //图片放大
import moment from 'moment';
export default {
	components:{
		navbar,
		footerBox,
		fixed
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			nowList: null,
			nowContent: '',
			metaDescription: '',
			metaKeywords: ''
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求产品信息
		productInfo({
			custom: that.$route.name
		}).then(res => {
			that.infoData = res.data;
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			if(that.infoData.tags.length > 0) {
				that.nowList = that.infoData.tags[0].id;
				that.nowContent = that.infoData.tags[0].content;
			}
			that.isLoading = false;
			//统计访问
			let time = String(moment(new Date()).valueOf());
			setTimeout(() => {
				productCount({
					language: sessionStorage.getItem('lang') == 'en' ? 2 : 1,
					cate_id: that.infoData.cate_id,
					cert_id: that.infoData.cert_id,
					productid: that.infoData.id,
					url: that.$route.name,
					addtime: time,
					sign: md5(String(that.infoData.cate_id) + String(that.infoData.cert_id) + String(that.infoData.id) + that.$route.name + String(time) + 'CorDx2023'),
				}).then(res2 => {});
			}, 10000);
		});
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//查看大图
		showBig(value) {
			let that = this;
			ImagePreview({
				closeable: true,
				showIndicators: false,
				showIndex: false,
				images: [value],
				startPosition: 0
			});
		},
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		//底部列表点击
		listClick(value) {
			let that = this;
			that.nowList = value.id;
			that.nowContent = value.content;
		},
		goForm() {
			window.location.href = 'https://9503031.extforms.netsuite.com/app/site/crm/externalleadpage.nl?compid=9503031&formid=1&h=AAFdikaIQ2PXFz401i3VE_HOLtHYK7BnQWKsJ4kggWf6fmweWho';
		}
	}
}
</script>

<style scoped lang="less">
.col_b{
	color: #25438c;
}
.col_o{
	color: #f16f33;
}
.main_box{
	//块5
	.block_5{
		padding: 0px 20px 50px 20px;
		.tit{
			padding-bottom: 30px;
			font-size: 20px;
			font-weight: bold;
			text-align: center;
		}
		.content{
			padding: 0 20px;
			border: 1px solid #0B318F;
		}
		.list_box{
			.list_el{
				display: inline-block;
				margin: 0 10px 20px 0;
				padding: 10px 20px;
				font-size: 18px;
				background-color: #EFEFEF;
				color: #000000;
				cursor: pointer;
			}
			.list_el.actived{
				color: #ffffff;
				background-color: #0B318F;
			}
		}
	}
	//块4
	.block_4{
		margin-bottom: 50px;
		padding: 50px 20px;
		background-color: #d0edff;
		.text{
			padding-top: 10px;
			font-size: 18px;
			text-align: center;
		}
		.title{
			font-size: 24px;
			font-weight: bold;
			text-align: center;
			span{
				font-size: 24px;
				font-weight: bold;
				color: #0B318F;
			}
		}
	}
	//块3
	.block_3{
		position: relative;
		padding: 0px 0 50px 0;
		overflow: hidden;
		.block_3_main{
			width: 100%;
			padding: 0 20px;
			.info_box{
				padding-top: 30px;
				.title_box{
					padding-top: 10px;
					.txt{
						padding-top: 5px;
						font-size: 16px;
					}
					.tit{
						font-size: 20px;
						font-weight: bold;
					}
				}
				.img_box{
					text-align: center;
					img{
						height: 120px;
						object-fit: cover;
					}
				}
			}
			.msg_box{
				padding-top: 20px;
				text-align: center;
				.txt_box{
					padding-top: 20px;
					text-align: left;
					.txt_el{
						display: flex;
						padding: 5px 0;
						.right{
							flex: 1;
							padding-left: 5px;
							font-size: 20px;
							color: #333333;
						}
						.left{
							width: auto;
							font-size: 20px;
							color: #333333;
						}
					}
				}
				img{
					width: 60%;
				}
			}
			.title{
				padding-top: 50px;
				font-size: 24px;
				text-align: center;
				font-weight: bold;
			}
		}
	}
	//块2
	.block_2{
		position: relative;
		padding: 0px 0 0px 0;
		overflow: hidden;
		.block_2_main{
			width: 100%;
			padding: 0 20px;
			.txt_box{
				padding-top: 10px;
				.txt_el{
					padding: 5px 0;
					font-size: 20px;
					color: #333333;
				}
			}
			.title{
				text-align: center;
				font-size: 24px;
				font-weight: bold;
			}
		}
	}
	//块1
	.block_1{
		position: relative;
		padding: 20px 0 50px 0;
		.block_1_main{
			width: 100%;
			padding: 0 20px;
			.table_box{
				padding-top: 20px;
				.tips{
					padding-top: 5px;
					font-size: 14px;
					color: #666666;
				}
				.table_el{
					img{
						width: 100%;
					}
				}
				.tit{
					padding-bottom: 5px;
					font-size: 20px;
					font-weight: bold;
				}
			}
			.text{
				padding-top: 10px;
				font-size: 18px;
				text-align: center;
			}
			.title{
				font-size: 24px;
				font-weight: bold;
				text-align: center;
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.banner_main{
			width: 100%;
			padding: 30px 20px;
			.left{
				flex: 1;
				.btn_box{
					width: 70%;
					display: inline-block;
					padding: 10px 0 8px 0;
					font-size: 18px;
					color: #ffffff;
					border-radius: 24px;
					text-align: center;
					background-color: #25438c;
					cursor: pointer;
				}
				.txt_box{
					padding: 15px 0 20px 0;
					.txt_el{
						padding: 8px 0;
						font-size: 20px;
						color: #f16f33;
						font-weight: bold;
						img{
							width: 24px;
							position: relative;
							top: -1px;
						}
					}
				}
				.text{
					padding-top: 20px;
					font-size: 20px;
				}
				.title2{
					img{
						width: 100%;
					}
				}
				.title1{
					span{
						font-size: 30px;
						font-weight: bold;
					}
				}
			}
			.right{
				flex: 1;
			}
		}
	}
	//引导块
	.tips_box{
		padding: 40px 20px 10px 20px;
		background: linear-gradient(to right, #F2F7FD, transparent);
		.tips_main{
			font-size: 16px;
			span{
				font-size: 16px;
				color: #0B318F;
			}
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .block_1_box p{
	margin: 0;
}
</style>